// src/products/equityManager/utils/currencyFormatter.js
// Utility function to format currency with K (thousands) or M (millions) suffixes for large amounts

import CurrencyService from '../../../services/currencyService';

export const formatCurrencyWithUnits = (amount, currency = 'USD', locale = 'en-US') => {
  if (amount === null || amount === undefined || isNaN(amount)) return CurrencyService.formatAmount(0, currency, locale);
  
  const absAmount = Math.abs(amount);
  const currencyData = CurrencyService.getCurrencyByCode(currency);
  const symbol = currencyData ? currencyData.symbol : currency;
  
  // For amounts >= 1 million, use M (millions)
  if (absAmount >= 1000000) {
    const millions = amount / 1000000;
    // Show 1 decimal place if less than 10M, otherwise no decimals
    if (absAmount < 10000000) {
      return `${symbol}${millions.toFixed(1)}M`;
    }
    return `${symbol}${Math.round(millions)}M`;
  }
  
  // For amounts >= 1 thousand, use K (thousands)
  if (absAmount >= 1000) {
    const thousands = amount / 1000;
    // Show 1 decimal place if less than 10K, otherwise no decimals
    if (absAmount < 10000) {
      return `${symbol}${thousands.toFixed(1)}K`;
    }
    return `${symbol}${Math.round(thousands)}K`;
  }
  
  // For amounts < 1000, use standard currency formatting
  return CurrencyService.formatAmount(amount, currency, locale);
};

export default formatCurrencyWithUnits;
